import { render } from "./ChatMessageGeneral.vue?vue&type=template&id=12bc93b0"
import script from "./ChatMessageGeneral.vue?vue&type=script&lang=js"
export * from "./ChatMessageGeneral.vue?vue&type=script&lang=js"

import "./ChatMessageGeneral.vue?vue&type=style&index=0&id=12bc93b0&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__